/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useCodeSuggestions
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import _ from 'lodash';

import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';

/**
 * use code suggestions hook
 * @returns {UseQueryResult} useCodeSuggestions
 */
const useCodeSuggestions = (searchModel: CodeExplorer.ICodeSetSearch): UseQueryResult<CodeExplorer.ICodeSetSuggestions> => {
	return useQuery({
		queryKey: [QUERY_KEYS.codeSuggestions, searchModel],
		queryFn: async () => {
			const { data } = await api.CodeExplorerApi.codeSuggestions({ codeSetSearch: searchModel });
			return data;
		},
		enabled: _.size(searchModel.searchterm) >= 2,
	});
};

export default useCodeSuggestions;
